module.exports = __webpack_public_path__ + "static/media/gold-medal.3368d67d.png";